import React, { SVGProps } from 'react';

export function LockIconSimple({
  color = '#5D666D',
  height = 20,
  strokeWidth = '2.5',
  width = 20,
  ...props
}: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 21 23' fill='none' {...props}>
      <title>Lock Icon Simple</title>
      <path
        d='M5.25391 10.2513V6.25075C5.25391 4.92447 5.78069 3.65251 6.71837 2.71469C7.65605 1.77686 8.92782 1.25 10.2539 1.25C11.58 1.25 12.8518 1.77686 13.7894 2.71469C14.7271 3.65251 15.2539 4.92447 15.2539 6.25075V10.2513M3.25 10.2484H17.25C18.3546 10.2484 19.25 11.1439 19.25 12.2487V19.2497C19.25 20.3544 18.3546 21.25 17.25 21.25H3.25C2.14543 21.25 1.25 20.3544 1.25 19.2497V12.2487C1.25 11.1439 2.14543 10.2484 3.25 10.2484Z'
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
